import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AddLayersFormModule } from './components/add-layers-form/add-layers-form.module';
import { QuotaInfoModule } from './components/quota-info/quota-info.module';
import { MapToolListModule } from './components/map-tool-list/map-tool-list.module';
import { ModalModule } from '../modal/modal.module';
import { MainMapComponent } from './main-map.component';
import { AddressSearchBarModule } from './components/address-search-bar/address-search-bar.module';
import { LoadDataFormModule } from './components/load-data-form/load-data-form.module';
import { InfluenceAreaModule } from './components/influence-area/influence-area.module';
import { SearchResultsModule } from './components/search-results/search-results.module';
import { ScaleBarModule } from './components/scale-bar/scale-bar.module';
import { TocModule } from './components/toc/toc.module';
import { MeasurementModule } from './components/measurement/measurement.module';
import { ProjectionModule } from './components/projection/projection.module';
import { RegisterElementMapModule } from './components/register-element-map/register-element-map.module';
import { MapsManagementModule } from './components/maps-management/maps-management.module';
import { PrintMapFormModule } from './components/print-map-form/print-map-form.module';
import { ConvertCoordinatesModule } from './components/convert-coordinates/convert-coordinates.module';
import { HeatmapLayersModule } from './components/heatmap-layers/heatmap-layers.module';
import { ClusterLayersModule } from './components/cluster-layers/cluster-layers.module';
import { LayersInfoService } from './layers.service';
import { OccurrencesManagementModule } from './components/occurrences-management/occurrences-management.module';
import { NotesModule } from './components/notes/notes.module';
import { SearchAnnouncementModule } from './components/search-announcement/search-announcement.module';
import { IdentifyModule } from './components/identify/identify.module';
import { HelpModule } from './components/help/help.module';
import { SearchResultsInternalModule } from './components/search-results-internal/search-results-internal.module';
import { OverviewMapModule } from './components/overview-map/overview-map.module';
import { EventsRegisterModule } from './components/events-register/events-register.module';
import { CalcPathModule } from './components/calc-path/calc-path.module';
import { BottomSheetModule } from '../bottom-sheet/bottom-sheet.module';
import { IconicModule } from '../iconic/iconic.module';
import { ShareMapLinkModalModule } from './components/share-map-link-modal/share-map-link-modal.module';
import { ProjectionLabelModule } from './components/projection-label/projection-label.module';
import { AvailableCoverageComponent } from './components/available-coverage/available-coverage.component';
import { SplashModalComponent } from './components/splash-modal/splash-modal.component';
import { TranslationButtonModule } from '@components/translation-button/translation-button.module';

@NgModule({
  imports: [
    CommonModule,
    IconicModule,
    MapToolListModule,
    ScaleBarModule,
    TocModule,
    ModalModule,
    BottomSheetModule,
    HeatmapLayersModule,
    ClusterLayersModule,
    AddLayersFormModule,
    QuotaInfoModule,
    LoadDataFormModule,
    AddressSearchBarModule,
    InfluenceAreaModule,
    SearchResultsModule,
    SearchResultsInternalModule,
    MeasurementModule,
    ProjectionModule,
    RegisterElementMapModule,
    EventsRegisterModule,
    MapsManagementModule,
    CalcPathModule,
    PrintMapFormModule,
    ConvertCoordinatesModule,
    NotesModule,
    OccurrencesManagementModule,
    SearchAnnouncementModule,
    IdentifyModule,
    HelpModule,
    OverviewMapModule,
    ShareMapLinkModalModule,
    ProjectionLabelModule,
    AvailableCoverageComponent,
    SplashModalComponent,
    TranslationButtonModule,
  ],
  declarations: [MainMapComponent],
  exports: [MainMapComponent],
  providers: [LayersInfoService],
})
export class MainMapModule {}
